import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  Typography,
  Grid,
} from "@mui/material";
import cross from "../../assets/img/cross.png";
import { updateUser } from "../../api/Api";
import { useTheme } from "@mui/material/styles";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  borderRadius: 1,
  boxShadow: "none",
};

const UpdateUserModal = ({ open, handleClose, userData, handleUpdateUser }) => {
  const theme = useTheme();
  // console.log('address',userData);
  const[loading,setLoading]=useState(false);
  const [updatedData, setUpdatedData] = useState({
    name: "",
    contactNo: "",
    area: "",
    deliveryAddress: "",
  });
  // Update state when userData changes
  useEffect(() => {
    if (userData) {
      setUpdatedData({
        name: userData.name || "",
        contactNo: userData.phone || "",
        area: userData.area || "",
        deliveryAddress: userData.area || "",
      });
    }
  }, [userData]);

  // Handle input changes
  const handleChange = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submission
 const handleUpdate = async (e) => {
    e.preventDefault();

    // Map the fields to match the API requirements
    const apiData = {
      phone: updatedData.contactNo,
      address: updatedData.deliveryAddress,
      email: userData.email, // Assuming email comes from userData
    };

    try {
      setLoading(true);
      // Call the updateUser API
      const response = await updateUser(apiData);
      console.log("User updated successfully:", response);
      handleUpdateUser(updatedData);
      handleClose();
      setLoading(false);
    } catch (error) {
      console.error("Error updating user:", error);
      // Optionally handle error feedback
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.1)" }, // Light background
      }}
    >
      <Box sx={style} component="form" onSubmit={handleUpdate}>
        {/* Modal Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: "20px",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" component="h2">
            Update User Details
          </Typography>
          <Box
            component="img"
            src={cross}
            alt="Close"
            sx={{
              width: "30px",
              height: "30px",
              cursor: "pointer",
            }}
            onClick={handleClose}
          />
        </Box>

        {/* Modal Body */}
        <Box sx={{ padding: "20px" }}>
          <Grid container spacing={2}>
            {/* Name */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={updatedData.name}
                onChange={handleChange}
                variant="outlined"
                required
              />
            </Grid>

            {/* Contact Number */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Contact No"
                name="contactNo"
                value={updatedData.contactNo}
                onChange={handleChange}
                variant="outlined"
                required
                InputLabelProps={{
                  shrink: Boolean(updatedData.contactNo), // Ensure the label floats correctly
                }}
              />
            </Grid>

            {/* Area */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Area"
                name="area"
                value={updatedData.area}
                onChange={handleChange}
                variant="outlined"
                required
              />
            </Grid>

            {/* Delivery Address */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Delivery Address"
                name="deliveryAddress"
                value={updatedData.deliveryAddress}
                onChange={handleChange}
                multiline
                rows={3}
                variant="outlined"
                required
              />
            </Grid>
          </Grid>
        </Box>

        {/* Save Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
           <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading} // Disable button when loading
              sx={{
                width: "180px",
                height: "50px",
                backgroundColor: theme.palette.primary.light,
                textTransform: "capitalize",
              }}
            >
              {loading ? "Please wait..." : "Update Data"}
            </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateUserModal;
